import React, {useMemo} from 'react'
import WizSelect from '../../../../components/select/WizSelect'
import WizSelectButton from '../../../../components/button/WizSelectButton'
import Text from '../../../../components/text/Text'

interface IProps {
    className?: string
    sortBy: string
    onChangeSort: (e: any) => void
    exchange: string
    onChangeExchange: (e: any) => void
    status: string
    onChangeStatus: (e: any) => void
}

const CopierSortContainer: React.FC<IProps> = ({
    className,
    exchange,
    onChangeExchange,
    sortBy,
    onChangeSort,
    status,
    onChangeStatus,
}) => {
    const sortList = useMemo(
        () => [
            {id: 'created_at', value: 'Create At'},
            {id: 'balance', value: 'Balance'},
            {id: 'earning', value: 'Earning'},
            {id: 'profit', value: 'Profit'},
        ],
        [],
    )

    const statusList = useMemo(() => {
        return [
            {id: 'running', value: 'Running'},
            {id: 'all', value: 'All'},
            {id: 'paused', value: 'Paused'},
        ]
    }, [])

    return (
        <div className={'flex items-center gap-x-[20px] md:block md:gap-x-0 md:space-y-[30px]'}>
            <div>
                <Text className={'hidden md:block text-center text-font03 text-ti3 pb-[5px]'}>Exchanges</Text>
                <WizSelect
                    optionKey="exchange"
                    value={exchange}
                    onChange={onChangeExchange}
                    className={'md:w-min md:mx-auto'}
                />
            </div>
            <div>
                <Text className={'hidden md:block text-center text-font03 text-ti3 pb-[5px]'}>Sort</Text>
                <WizSelectButton
                    onChange={e => {
                        onChangeSort(e.id)
                    }}
                    data={sortList}
                    activeValue={sortList?.find(item => item.id === sortBy)}
                    className={'md:mx-auto sm:hidden'}
                />

                <WizSelect
                    optionKey="copierSort"
                    onChange={onChangeSort}
                    className={'hidden sm:block sm:w-min sm:mx-auto'}
                />
            </div>

            <div>
                <Text className={'hidden md:block text-center text-font03 text-ti3 pb-[5px]'}>Status</Text>
                <WizSelectButton
                    onChange={e => {
                        onChangeStatus(e.id)
                    }}
                    data={statusList}
                    activeValue={statusList?.find(item => item.id === status)}
                    className={'md:mx-auto'}
                />
            </div>
        </div>
    )
}

export default CopierSortContainer
